/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getEspecialties } from 'app/entities/especialty/especialty.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getPatientAttributeTypes } from 'app/entities/patient-attribute-type/patient-attribute-type.reducer';
import { getEntities as getClinicalDictionaryTypes } from 'app/entities/clinical-dictionary-type/clinical-dictionary-type.reducer';
import { createEntity, getEntity, reset, updateEntity } from './patient-attribute-type.reducer';

export const PatientAttributeTypeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const especialties = useAppSelector(state => state.especialty.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const patientAttributeTypes = useAppSelector(state => state.patientAttributeType.entities);
  const clinicalDictionaryTypes = useAppSelector(state => state.clinicalDictionaryType.entities);
  const patientAttributeTypeEntity = useAppSelector(state => state.patientAttributeType.entity);
  const loading = useAppSelector(state => state.patientAttributeType.loading);
  const updating = useAppSelector(state => state.patientAttributeType.updating);
  const updateSuccess = useAppSelector(state => state.patientAttributeType.updateSuccess);

  const handleClose = () => {
    navigate(`/patient-attribute-type${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getEspecialties({}));
    dispatch(getHospitals({}));
    dispatch(getPatientAttributeTypes({}));
    dispatch(getClinicalDictionaryTypes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...patientAttributeTypeEntity,
      ...values,
      specialty: especialties.find(it => it.id.toString() === values.specialty?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      parent: patientAttributeTypes.find(it => it.id.toString() === values.parent?.toString()),
      clinicalDictionaryType: clinicalDictionaryTypes.find(it => it.id.toString() === values.clinicalDictionaryType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...patientAttributeTypeEntity,
          specialty: patientAttributeTypeEntity?.specialty?.id,
          hospital: patientAttributeTypeEntity?.hospital?.id,
          parent: patientAttributeTypeEntity?.parent?.id,
          clinicalDictionaryType: patientAttributeTypeEntity?.clinicalDictionaryType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.patientAttributeType.home.createOrEditLabel" data-cy="PatientAttributeTypeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.patientAttributeType.home.createOrEditLabel">
              Create or edit a PatientAttributeType
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="patient-attribute-type-id"
                  label={translate('tinyMedicRestApp.patientAttributeType.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.patientAttributeType.active')}
                id="patient-attribute-type-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientAttributeType.lastUpdated')}
                id="patient-attribute-type-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientAttributeType.timestampEntry')}
                id="patient-attribute-type-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientAttributeType.microSec')}
                id="patient-attribute-type-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientAttributeType.cursor')}
                id="patient-attribute-type-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientAttributeType.title')}
                id="patient-attribute-type-title"
                name="title"
                data-cy="title"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientAttributeType.unitsOfMeasure')}
                id="patient-attribute-type-unitsOfMeasure"
                name="unitsOfMeasure"
                data-cy="unitsOfMeasure"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientAttributeType.valueType')}
                id="patient-attribute-type-valueType"
                name="valueType"
                data-cy="valueType"
                type="text"
                validate={{
                  maxLength: { value: 200, message: translate('entity.validation.maxlength', { max: 200 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientAttributeType.valueRange')}
                id="patient-attribute-type-valueRange"
                name="valueRange"
                data-cy="valueRange"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientAttributeType.group')}
                id="patient-attribute-type-group"
                name="group"
                data-cy="group"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientAttributeType.isReqForRegistration')}
                id="patient-attribute-type-isReqForRegistration"
                name="isReqForRegistration"
                data-cy="isReqForRegistration"
                check
                type="checkbox"
              />
              <ValidatedField
                id="patient-attribute-type-specialty"
                name="specialty"
                data-cy="specialty"
                label={translate('tinyMedicRestApp.patientAttributeType.specialty')}
                type="select"
              >
                <option value="" key="0" />
                {especialties
                  ? especialties.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-attribute-type-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.patientAttributeType.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-attribute-type-parent"
                name="parent"
                data-cy="parent"
                label={translate('tinyMedicRestApp.patientAttributeType.parent')}
                type="select"
              >
                <option value="" key="0" />
                {patientAttributeTypes
                  ? patientAttributeTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-attribute-type-clinicalDictionaryType"
                name="clinicalDictionaryType"
                data-cy="clinicalDictionaryType"
                label={translate('tinyMedicRestApp.patientAttributeType.clinicalDictionaryType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaryTypes
                  ? clinicalDictionaryTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/patient-attribute-type" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PatientAttributeTypeUpdate;
